document.addEventListener('DOMContentLoaded', async () => {
  const brandSelect = document.getElementById('brandSelect');
  const modelSelect = document.getElementById('modelSelect');
  const resultsDiv = document.getElementById('results');

  if (!brandSelect || !modelSelect || !resultsDiv) return;

  // Store minimal data: { handle, tags } for filtering
  let productIndex = [];
  // Cache full product details after first load
  let productCache = {};

  function setLoading(element, text) {
    element.innerHTML = `<option value="">${text}</option>`;
    element.disabled = true;
  }

  // Phase 1: Load only handles and tags (fast)
  async function loadProductIndex() {
    setLoading(brandSelect, 'Loading brands...');
    resultsDiv.innerHTML = '<p>Loading...</p>';

    let page = 1;
    const limit = 250;
    const maxPages = 20;

    try {
      while (page <= maxPages) {
        const response = await fetch(`/products.json?limit=${limit}&page=${page}&fields=handle,tags`);
        
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        
        const data = await response.json();
        const products = data.products || [];

        if (products.length === 0) break;

        // Store only what we need for filtering
        products.forEach(p => {
          if (p.tags && p.tags.some(t => typeof t === 'string' && t.startsWith('devicebrand-'))) {
            productIndex.push({
              handle: p.handle,
              tags: p.tags
            });
          }
        });

        if (products.length < limit) break;
        page++;
      }

      resultsDiv.innerHTML = '';
      populateBrands();
      
    } catch (error) {
      console.error('Failed to load:', error);
      resultsDiv.innerHTML = '<p style="color:red">Error loading. Please refresh.</p>';
      setLoading(brandSelect, 'Error');
    }
  }

  // Phase 2: Load full product details only when needed
  async function loadProductDetails(handles) {
    const uniqueHandles = [...new Set(handles)].filter(h => !productCache[h]);
    
    if (uniqueHandles.length === 0) return;

    // Fetch in batches of 20 (adjust based on performance)
    const batchSize = 20;
    for (let i = 0; i < uniqueHandles.length; i += batchSize) {
      const batch = uniqueHandles.slice(i, i + batchSize);
      
      await Promise.all(batch.map(async (handle) => {
        try {
          const response = await fetch(`/products/${handle}.json`);
          if (!response.ok) return;
          
          const data = await response.json();
          productCache[handle] = data.product;
        } catch (e) {
          console.error(`Failed to load ${handle}:`, e);
        }
      }));
    }
  }

  function getTagValue(tag, prefix) {
    return tag.replace(prefix, '');
  }

  function formatLabel(str) {
    return str
      .replace(/-/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  function getPrice(product) {
    if (!product.variants || !product.variants[0]) return '';
    const price = product.variants[0].price;
    if (typeof price === 'string') return parseFloat(price).toFixed(2);
    if (typeof price === 'number') return price > 1000 ? (price / 100).toFixed(2) : price.toFixed(2);
    return '';
  }

  function getImage(product) {
    if (product.images && product.images[0]) return product.images[0].src;
    if (product.image && product.image.src) return product.image.src;
    return '';
  }

  function populateBrands() {
    const brands = new Set();

    productIndex.forEach(p => {
      p.tags.forEach(tag => {
        if (typeof tag === 'string' && tag.startsWith('devicebrand-')) {
          brands.add(getTagValue(tag, 'devicebrand-'));
        }
      });
    });

    brandSelect.innerHTML = '<option value="">Select Brand</option>';
    
    [...brands].sort().forEach(brand => {
      const option = document.createElement('option');
      option.value = brand;
      option.textContent = formatLabel(brand);
      brandSelect.appendChild(option);
    });

    brandSelect.disabled = false;
  }

  brandSelect.addEventListener('change', () => {
    const selectedBrand = brandSelect.value;

    modelSelect.innerHTML = '<option value="">Select Model</option>';
    resultsDiv.innerHTML = '';

    if (!selectedBrand) {
      modelSelect.disabled = true;
      return;
    }

    setLoading(modelSelect, 'Loading models...');

    const brandTag = `devicebrand-${selectedBrand}`;
    const models = new Set();

    productIndex.forEach(p => {
      if (p.tags.includes(brandTag)) {
        p.tags.forEach(tag => {
          if (typeof tag === 'string' && tag.startsWith('devicemodel-')) {
            models.add(getTagValue(tag, 'devicemodel-'));
          }
        });
      }
    });

    modelSelect.innerHTML = '<option value="">Select Model</option>';
    
    [...models].sort().forEach(model => {
      const option = document.createElement('option');
      option.value = model;
      option.textContent = formatLabel(model);
      modelSelect.appendChild(option);
    });

    modelSelect.disabled = false;
  });

  modelSelect.addEventListener('change', async () => {
    const selectedBrand = brandSelect.value;
    const selectedModel = modelSelect.value;
    resultsDiv.innerHTML = '';

    if (!selectedBrand || !selectedModel) return;

    const brandTag = `devicebrand-${selectedBrand}`;
    const modelTag = `devicemodel-${selectedModel}`;

    // Find matching handles from index
    const matchingHandles = productIndex
      .filter(p => p.tags.includes(brandTag) && p.tags.includes(modelTag))
      .map(p => p.handle);

    if (!matchingHandles.length) {
      resultsDiv.innerHTML = '<p>No compatible cases found.</p>';
      return;
    }

    resultsDiv.innerHTML = '<p>Loading products...</p>';

    // Load full details only for matching products
    await loadProductDetails(matchingHandles);

    resultsDiv.innerHTML = '';

    matchingHandles.forEach(handle => {
      const product = productCache[handle];
      if (!product) return;

      const image = getImage(product);
      const price = getPrice(product);

      // Open in new tab
      resultsDiv.innerHTML += `
        <a href="/products/${product.handle}" 
           target="_blank" 
           rel="noopener noreferrer"
           class="result-card">
          ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
          <h3>${product.title}</h3>
          ${price ? `<p class="price">£${price}</p>` : ''}
        </a>
      `;
    });
  });

  loadProductIndex();
});